<template>
  <div>
    <CCallout color="s3green" v-if="typeIndicator === 'Ventas'">
      <span class="text-muted">Ventas</span>
      <div>
        <i class="bi bi-cart3 h2 text-s3green mr-3"></i>
        <strong class="h4">${{ formatter.format(valorVentas, 2) }}{{ simboloValores }}</strong>
      </div>
    </CCallout>
    <CCallout color="s3red" v-if="typeIndicator === 'Remisiones Periodo'">
      <span class="text-muted">Remisiones</span>
      <div>
        <i class="bi bi-box-seam h2 text-s3red mr-3"></i>
        <strong class="h4">${{ formatter.format(valorRemisiones, 2) }}M</strong>
      </div>
    </CCallout>
    <CCallout color="s3orange" v-if="typeIndicator === 'Cotizaciones Periodo'">
      <span class="text-muted">Cotizaciones</span>
      <div>
        <i class="bi bi-envelope-paper h2 text-s3orange mr-3"></i>
        <strong class="h4">${{ formatter.format(valorCotizaciones, 2) }}M</strong>
      </div>
    </CCallout>
    <CCallout color="s3orange" v-if="typeIndicator === 'Pedidos'">
      <span class="text-muted">Pedidos</span>
      <div>
        <i class="bi bi-envelope-paper h2 text-s3orange mr-3"></i>
        <strong class="h4">${{ formatter.format(valorPedidos, 2) }}M</strong>
      </div>
    </CCallout>
    <CCallout color="s3purple" v-if="typeIndicator === 'Recaudos'">
      <span class="text-muted">Recaudos</span>
      <div>
        <Icon icon="fluent:money-hand-24-regular" class="text-s3purple mt-1 mr-3" width="28"/>
        <!-- <i class="bi bi-cash-coin h2 text-s3purple mr-3"></i> -->
        <strong class="h4 align-middle">${{ formatter.format(valorRecaudos, 2) }}M</strong>
      </div>
    </CCallout>

    <CCallout color="danger" v-if="typeIndicator === 'Cartera'">
      <span class="text-muted">Cartera</span>
      <div>
        <i class="bi bi-cash-coin h2 text-danger mr-3"></i>
        <strong class="h4 align-middle">${{ formatter.format(valorCartera, 2) }}M</strong>
      </div>
    </CCallout>
    <CCallout color="s3purple" v-if="typeIndicator === 'EntregasMercancia'">
      <span class="text-muted">Total Remisiones</span>
      <div>
        <Icon icon="fluent:money-hand-24-regular" class="text-s3purple mt-1 mr-3" width="28"/>
        <!-- <i class="bi bi-cash-coin h2 text-s3purple mr-3"></i> -->
        <strong class="h4 align-middle">${{ formatter.format(valorRemisiones, 2) }}M</strong>
      </div>
    </CCallout>

    <LoadingCover v-show="loading" spinner="dotsbar" />
  </div>
</template>

<script>
  import { Icon } from "@iconify/vue2"
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import { formatter } from "@/general";
  import { 
    dataKPIDocumentValues,
  } from "@/apiData"

  export default {
    name: "DocumentValuesIndicatorPanel",
    data() {
      return {
        formatter,
        loading: false,
        simboloValores: "",
        valorCartera: 0,
        valorVentas: 0,
        valorRemisiones: 0,
        valorCotizaciones: 0,
        valorPedidos: 0,
        valorRecaudos: 0,
        valorCompras: 0
      }
    },
    props: {
      typeIndicator: String,
      initialDate: String,
      finalDate: String,
      idStaffGroup: String,
      idEmployee: String
    },
    components: {
      Icon,
      LoadingCover
    },
    methods: {
      async getDataKPIDocumentValues() {
        this.loading = true;

        try {
          const { response } = await dataKPIDocumentValues(
            this,
            this.initialDate,
            this.finalDate,
            this.typeIndicator,
            this.idStaffGroup,
            this.idEmployee
          );

          let valorIndicador = response.Valor;
          valorIndicador = (valorIndicador / 1000)

          if (valorIndicador > 1000) {
            valorIndicador = valorIndicador / 1000;
            this.simboloValores = "M";
          } else {
            this.simboloValores = "K";
          }

          switch (this.typeIndicator) {
            case "Cotizaciones Periodo":
              this.valorCotizaciones = valorIndicador;
              break;
            case "Remisiones Periodo":
              this.valorRemisiones = valorIndicador;
              break;
            case "Ventas":
              this.valorVentas = valorIndicador;
              break;
            case "Recaudos":
              this.valorRecaudos = valorIndicador;
              break;
            case "Cartera":
              this.valorCartera = valorIndicador;
              break;
          }


        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    async mounted() {
      await this.getDataKPIDocumentValues();
    }
  }
</script>
